var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-unique"},[_c('img',{staticClass:"logobrandfooter",attrs:{"src":require("@/assets/img/logo-brand-footer.png"),"alt":""}}),_c('p',[_vm._v(" Copyright © 2019 LG lugar de gente - Todos os direitos reservados. ")])])])])
}]

export { render, staticRenderFns }